<template>
  <div class="bt-anggota pa-5">
    <div class="mb-5">
      <v-card class="overflow-hidden elevation-3 rounded-lg mb-3">
        <v-card-text>
          <v-autocomplete label="Rembug" class="mb-4 font-weight-medium" hide-details :items="rembug"
            item-text="cm_name" item-value="cm_code" v-model="cm_code" readonly />
          <v-autocomplete label="Kelompok" class="mb-4 font-weight-medium" hide-details :items="kelompok"
            item-text="nama_kelompok" item-value="kode_kelompok" v-model="kode_kelompok" readonly />
          <v-menu ref="menu" v-model="dateShow" :close-on-content-click="false" :return-value.sync="transaction_date"
            transition="scale-transition" offset-y min-width="auto" class="white" disabled>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="transaction_date" label="Tanggal" class="font-weight-medium" readonly
                v-bind="attrs" v-on="on" />
            </template>
            <v-date-picker v-model="transaction_date" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dateShow = false"> Cancel </v-btn>
              <v-btn text color="primary"> OK </v-btn>
            </v-date-picker>
          </v-menu>
        </v-card-text>
      </v-card>

      <v-card class="elevation-3 rounded-lg pa-3 align-items-end mb-3">
        <div class="d-flex justify-space-between">
          <span><b>Total Setoran</b></span>
          <h4>Rp {{ thousand(total_setoran) }}</h4>
        </div>
      </v-card>

      <v-card class="elevation-3 rounded-lg pa-3 align-items-end mb-3" v-if="setoran && setoran.length == 0">
        <v-container class="d-flex justify-center pa-0">
          <div class="d-flex flex-column">
            <h6 class="text-subtitle-1 font-weight-bold">
              Memproses data...
            </h6>
          </div>
        </v-container>
      </v-card>

      <v-card class="rounded-lg mb-3 pt-3" v-else>
        <div v-for="(item, index) in setoran" :key="index">
          <div class="pl-3">
            <v-row class="ml-0 mt-0">
              <v-col cols="6">
                <label class="font-weight-bold">{{ item.nama }}</label>
              </v-col>
              <v-col cols="5">
                <v-text-field type="number" v-model="item.setoran" v-mask="thousandMask" min="1" inputmode="numeric"
                  @focus="selectAll($event)" @keydown="blockNonNumber($event)"
                  :rules="[() => !!item.setoran || 'This field is required']" dense></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-divider class="mb-5"></v-divider>
        </div>
      </v-card>

      <v-row class="mt-5">
        <v-col cols="6" class="pb-5 mb-5">
          <router-link :to="`/others/wakaf/kelompok/${cm_code}/${branch_id}/${transaction_date}`">
            <v-btn block class="purple lighten-1 white--text"> Kembali </v-btn>
          </router-link>
        </v-col>
        <v-col cols="6" class="pb-0">
          <v-btn block class="purple lighten-1 white--text" @click="doSave()"> Simpan </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Toast from "@/components/Toast";
import services from "@/services";
import helper from "@/utils/helper";
import { mapGetters } from "vuex";
export default {
  name: "WakafAnggota",
  components: {
    Toast,
    Header,
  },
  data() {
    return {
      rembug: [],
      kelompok: [],
      setoran: [],
      total_setoran: 0,
      cm_code: null,
      kode_kelompok: null,
      branch_id: null,
      transaction_date: null,
      dateShow: false,
      alert: {
        show: false,
        msg: "",
      },
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {
    setoran: {
      /**
       * Updates the `setoran` property of each `detail` object in `setoran` array
       * based on the `setoran` and `freq` properties of each `detail` object.
       *
       * @param {Array} newVal - The new value of the `setoran` array.
       * @param {Array} oldVal - The old value of the `setoran` array.
       */
      handler: function (newVal, oldVal) {
        if (newVal) {
          let total_setoran = 0;
          this.setoran.forEach((item) => {
            const setoran = Number(item.setoran ? String(item.setoran).replace(/\./g, "") : 0);

            total_setoran += setoran;
          });
          this.total_setoran = total_setoran;
        }
      },
      deep: true,
    },
  },
  methods: {
    ...helper,
    selectAll(e) {
      setTimeout(() => {
        e.target.select();
      }, 50);
    },

    blockNonNumber(e) {
      const allowed = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

      if (allowed.includes(e.key)) return;

      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },
    async getRembug() {
      this.$store.commit("setLoading", true);
      try {
        let payload = new FormData();
        payload.append("fa_code", this.user.fa_code);
        payload.append("hari_transaksi", "99");

        const response = await services.infoRembug(payload, this.user.token);
        if (response.status === 200 && Array.isArray(response.data.data)) {
          this.rembug = response.data.data;
        } else {
          this.rembug = [];
          this.$store.dispatch("showAlert", {
            show: false,
            msg: "",
          });
          setTimeout(() => {
            this.$store.dispatch("showAlert", {
              show: true,
              msg: `Kumpulan tidak ditemukan`,
              color: "warning",
              position: "top",
            });
          }, 50);
        }
      } catch (error) {
        this.$store.dispatch("showAlert", {
          show: false,
          msg: "",
        });
        setTimeout(() => {
          this.$store.dispatch("showAlert", {
            show: true,
            msg: error,
            color: "warning",
            position: "top",
          });
        }, 2500);
      } finally {
        this.$store.commit("setLoading", false);
      }
    },
    async getKelompok() {
      const fa_code = this.user.fa_code || null;
      const account_cash_code = this.user.account_cash_code || null;

      let payload = new FormData();
      payload.append("cm_code", this.cm_code);
      payload.append("branch_id", this.branch_id);
      payload.append("transaction_date", this.transaction_date);
      payload.append("fa_code", fa_code);
      payload.append("account_cash_code", account_cash_code);

      try {
        this.$store.commit("setLoading", true);
        const response = await services.infoGroup(payload, this.user.token);
        if (response.status === 200) {
          const { kelompok } = response.data.data;
          this.kelompok = kelompok;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        this.$store.dispatch("showAlert", {
          show: false,
          msg: "",
        });
        setTimeout(() => {
          this.$store.dispatch("showAlert", {
            show: true,
            msg: error,
            color: "warning",
            position: "top",
          });
        }, 50);
      } finally {
        this.$store.commit("setLoading", false);
      }
    },
    async getAnggota() {
      let payload = new FormData();
      payload.append("cm_code", this.cm_code);
      payload.append("kode_kelompok", this.kode_kelompok);
      payload.append("transaction_date", this.transaction_date);

      try {
        this.$store.commit("setLoading", true);
        const response = await services.infoMemberWakaf(payload, this.user.token);

        if (response.status === 200) {
          const { setoran = [], total_setoran = 0 } = response.data.data;

          for (let item of setoran) {
            if (item.detail) {
              for (let itemDetail of item.detail) {
                Object.assign(itemDetail, {
                  setoran_temp: itemDetail.setoran,
                });
              }
            }
          }

          this.setoran = setoran;
          this.total_setoran = total_setoran;
        } else {
          this.$store.dispatch("showAlert", {
            show: false,
            msg: "",
          });
          setTimeout(() => {
            this.$store.dispatch("showAlert", {
              show: true,
              msg: error,
              color: "error",
              position: "top",
            });
          }, 2500);
        }
      } catch (error) {
        this.$store.dispatch("showAlert", {
          show: false,
          msg: "",
        });
        setTimeout(() => {
          this.$store.dispatch("showAlert", {
            show: true,
            msg: error,
            color: "warning",
            position: "top",
          });
        }, 2500);
      } finally {
        this.$store.commit("setLoading", false);
      }
    },
    async doSave() {
      this.$store.commit("setLoading", true);
      try {
        let payload = new FormData();

        for (let [index, item] of this.setoran.entries()) {
          const { id = null, setoran = null } = item;

          if (setoran === null || setoran === "") {
            throw new Error(`Setoran tidak boleh kosong ${index}`);
          }

          payload.append(`id[${index}]`, id);
          payload.append(`setoran_wakaf[${index}]`, setoran);
        }

        const response = await services.transactionSetorWakaf(payload, this.user.token);

        if (response.status == 200) {
          this.$store.dispatch("showAlert", {
            show: false,
            msg: "",
          });
          setTimeout(() => {
            this.$store.dispatch("showAlert", {
              show: true,
              msg: response.data?.data?.msg || "Berhasil disimpan!",
              color: "success",
              position: "top",
            });
          }, 50);

          setTimeout(() => {
            this.$router.push(`/others/wakaf/kelompok/${this.cm_code}/${this.branch_id}/${this.transaction_date}`);
          }, 500);
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        this.$store.dispatch("showAlert", {
          show: false,
          msg: "",
        });
        setTimeout(() => {
          this.$store.dispatch("showAlert", {
            show: true,
            msg: error.message || error,
            color: "warning",
            position: "top",
          });
        }, 2500);
      } finally {
        this.$store.commit("setLoading", false);
      }
    },
  },
  mounted() {
    this.cm_code = this.$route.params.cm_code;
    this.branch_id = this.$route.params.branch_id;
    this.transaction_date = this.$route.params.transaction_date;
    this.kode_kelompok = parseInt(this.$route.params.kode_kelompok, 10);

    this.getRembug();
    this.getKelompok();
    this.getAnggota();
  },
};
</script>
